import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import ApiConfig from "src/apiconfig/apiconfig";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";

export const AuthContext = createContext();

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("creatturAccessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("creatturAccessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

function checkLogin(token) {
  const accessToken = window.localStorage.getItem("userToken") ?? token;
  return accessToken ? true : false;
}

export default function AuthProvider(props) {
  const [isLogin, setIsLogin] = useState(checkLogin());
  const [userData, setUserData] = useState({});
  const [timerActive, setTimerActive] = useState(false);
  const [remainingTime, setRemainingTime] = useState(180);
  const [expiredOTP, setExpiredOTP] = useState(false);
  const [topLeaderboardData, setListTopLeaderboardData] = useState([]);
  const [slideBannerdData, setSlideBannerData] = useState([]);

  const [slideSmallData, setslideSmallData] = useState([]);


  const history = useHistory();

  // Initialize timer from localStorage only once on mount
  useEffect(() => {
    const storedRemainingTime = localStorage.getItem("remainingTime");
    if (storedRemainingTime !== null) {
      const parsedTime = parseInt(storedRemainingTime, 10);
      setRemainingTime(parsedTime);
      if (parsedTime > 0) {
        setTimerActive(true);
      }
    }
  }, []); // Run only once on mount

  // Timer countdown effect - only depends on timerActive to prevent unnecessary re-renders
  useEffect(() => {
    if (!timerActive || remainingTime <= 0) {
      if (remainingTime === 0) {
        setTimerActive(false);
        setExpiredOTP(true);
        localStorage.removeItem("remainingTime");
      }
      return;
    }

    const timerInterval = setInterval(() => {
      setRemainingTime((prevTime) => {
        const newTime = prevTime - 1;
        localStorage.setItem("remainingTime", newTime.toString());
        if (newTime <= 0) {
          setTimerActive(false);
          setExpiredOTP(true);
          localStorage.removeItem("remainingTime");
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [timerActive, remainingTime]); // Keep remainingTime to stop timer when it reaches 0

  const getProfileHandler = async (token) => {
    try {
      const res = await axios({
        method: "GET",
        url: ApiConfig.getProfile,
        headers: {
          token: token,
        },
      });

      if (res?.data?.responseCode === 200) {
        setUserData(res?.data?.result);
      }
    } catch (error) {
      if (
        error?.response?.data?.responseCode === 500 ||
        error?.response?.data?.responseMessage === "jwt malformed" ||
        error?.response?.data?.responseMessage === "jwt expired"
      ) {
        toast.error("Session Expired Please Login Again");
        localStorage.removeItem("userToken");
        setIsLogin(false);
        if (history && typeof history.push === "function") {
          history.push("/login");
        } else {
          window.location.href = "/login";
        }
        // window.location.href = "/login";
      } else {
        // For other errors, just log them without showing toast
        // This prevents unwanted error messages during profile refresh
        console.warn("Failed to fetch profile:", error?.response?.data?.responseMessage || error.message);
      }
    }
  };
  const topLeaderboard = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: ApiConfig.listAdvertiseByType,
        params: {
          advertisementType: "TOPLEADERBOARD",
        },
      });

      if (res?.data?.responseCode === 200) {
        setListTopLeaderboardData(res?.data?.result?.docs);
      }
    } catch (error) {

      // if (error?.response) {
      //   toast.error(error.res?.data?.responseMessage);
      // }
    }
  };
  const slideBannerd = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: ApiConfig.listAdvertiseByType,
        params: {
          advertisementType: "SLIDEBANNER",
        },
      });

      if (res?.data?.responseCode === 200) {
        setSlideBannerData(res?.data?.result?.docs);
      }
    } catch (error) {

      // if (error?.response) {
      //   toast.error(error.res?.data?.responseMessage);
      // }
    }
  };
  const slideSmall = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: ApiConfig.listAdvertiseByType,
        params: {
          advertisementType: "SLIDESMALL",
        },
      });

      if (res?.data?.responseCode === 200) {
        setslideSmallData(res?.data?.result?.docs);
      }
    } catch (error) {

      // if (error?.response) {
      //   toast.error(error.res?.data?.responseMessage);
      // }
    }
  };

  useEffect(() => {
    let token = window.localStorage.getItem("userToken");
    if (token) {
      getProfileHandler(token);
    }
  }, [window.localStorage.getItem("userToken")]);
  useEffect(() => {
    topLeaderboard();
    slideBannerd();
    slideSmall();
  }, []);

  let data = {
    userLoggedIn: isLogin,
    userData,
    setTimerActive,
    expiredOTP,
    timerActive,
    setTimerActive,
    setRemainingTime,
    remainingTime,
    topLeaderboardData,
    slideBannerdData,
    slideSmallData,
    // setIsLogin,
    getProfileHandler: getProfileHandler,
    setUserData: setUserData, // Add setUserData to allow manual updates
    // listAllMilestone: listAllMilestone,

    userLogIn: (type, data) => {
      setSession(data);
      setIsLogin(type);
    },
    checkLogin: (token) => {
      checkLogin(token);
    },
  };

  return (
    <AuthContext.Provider value={data}>{props.children}</AuthContext.Provider>
  );
}
